<template>
  <b-modal ref="createForm" size="lg" hide-footer :title="$t('group-faq.message.add')">
    <div class="d-block">
      <form action="" v-on:submit.prevent="create()">
        <input type="hidden" v-model="group_faq.parent_id">
        <fieldset role="group" class="b-form-group form-group">
          <div role="group" class="">
            <label for="">{{ $t('group-faq.attribute.name') }} :</label>
            <div role="group" class="input-group">
              <input type="text" :placeholder="$t('group-faq.attribute.name')" class="form-control"
                v-model="group_faq.name">
            </div>
            <error :error="errors.name"></error>
          </div>
        </fieldset>
        <fieldset role="group" class="b-form-group form-group">
          <div role="group" class="">
            <label for="">{{ $t('group-faq.attribute.description') }} :</label>
            <div role="group" class="input-group">
              <textarea type="text" :placeholder="$t('group-faq.attribute.description')" class="form-control"
                v-model="group_faq.desc" />
            </div>
            <error :error="errors.desc"></error>
          </div>
        </fieldset>
        <button type="submit" class="btn btn-primary pull-right btn-sm" :disabled="btn_submit">
          <i class="fa fa-pencil"></i> {{ $t('user.button.add') }}</button>
      </form>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'create',
  components: {},
  props: [],
  data () {
    return {
      group_faq: {},
      errors: {},
      btn_submit: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    show () {
      this.group_faq = {}
      this.errors = {}
      this.btn_submit = false
      this.$refs.createForm.show()
    },
    hide () {
      this.$refs.createForm.hide()
    },
    create () {
      this.btn_submit = true

      this.$store.dispatch('GroupFAQ/createGroupFAQ', { group_faq: this.group_faq }).then(res => {
        this.btn_submit = false

        this.$emit('createSuccess', res)
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
      })
    }
  }
}

</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/group-faq/create.vue